import { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import axios from '../../api/axios';
import './JobPost.css';
import { MenuItem } from '@mui/material';

import axiosInstance from '../../api/axios';
const API_BASE_URL = axiosInstance.defaults.baseURL;

function JobPost() {
  // WebSocket connection
  useEffect(() => {
    const timeout = setTimeout(() => {
      const socket = new WebSocket(`ws://${window.location.hostname}:5001/ws`);

      socket.onopen = () => {
        // console.log('✅ WebSocket connected');
        socket.send('Hello server');
      };

      // socket.onmessage = (event) => {
      //   console.log('📩 Message from server:', event.data);
      // };

      socket.onclose = () => {
        console.log('❌ WebSocket disconnected');
      };
    }, 200);

    return () => clearTimeout(timeout);
  }, []);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [jobs, setJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [visibleJobs, setVisibleJobs] = useState(8);
  const [sortOption, setSortOption] = useState('recent');
  const [filterType, setFilterType] = useState('all');
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    link: '',
    image: null,
    draft: false,
  });

  const filteredJobs = [...jobs]
    .filter((job) => job.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .filter((job) => {
      if (filterType === 'published') return job.draft === false;
      if (filterType === 'draft') return job.draft === true;
      return true; // all
    })
    .sort((a, b) => {
      if (sortOption === 'recent')
        return new Date(b.createdAt) - new Date(a.createdAt);
      if (sortOption === 'oldest')
        return new Date(a.createdAt) - new Date(b.createdAt);
      if (sortOption === 'title') return a.title.localeCompare(b.title);
      return 0;
    });

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get('/api/jobs');
        setJobs(response.data);
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    };
    fetchJobs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
  };

  const handlePostJob = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('link', formData.link);
    formDataToSend.append('draft', formData.draft);

    if (formData.image) {
      formDataToSend.append('image', formData.image);
    }

    try {
      await axios.post('api/jobs', formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setOpen(false);
      window.location.reload();
    } catch (error) {
      console.error('Error adding job:', error);
    }
  };

  // Edit Job Handler
  const handleEditJob = (jobId) => {
    const job = jobs.find((job) => job._id === jobId);
    setFormData({
      title: job.title,
      description: job.description,
      link: job.link,
      image: job.image?.filePath || null,
      draft: job.draft || false,
    });
    setSelectedJobId(jobId);
    setEditMode(true);
    setOpen(true);
  };

  const handleUpdateJob = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('link', formData.link);
    formDataToSend.append('draft', formData.draft);

    if (formData.image) {
      formDataToSend.append('image', formData.image);
    }

    try {
      await axios.put(`api/jobs/${selectedJobId}`, formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setOpen(false);
      window.location.reload();
    } catch (error) {
      console.error('Error updating job:', error);
    }
  };

  // Open Confirm Delete Dialog
  const handleDeleteDialogOpen = (jobId) => {
    setSelectedJobId(jobId);
    setDeleteDialogOpen(true);
  };

  // Delete Job Handler
  const handleDeleteJob = async () => {
    try {
      await axios.delete(`api/jobs/${selectedJobId}`);
      setDeleteDialogOpen(false);
      window.location.reload();
    } catch (error) {
      console.error('Error deleting job:', error);
    }
  };

  return (
    <div className="job-container">
      <div className="job-main-content">
        <div className="job" style={{ display: 'flex', gap: '10px' }}>
          <TextField
            className="searchfield"
            label="Search Job"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <TextField
            select
            label="Sort By"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            size="small"
          >
            <MenuItem value="recent">Most Recent</MenuItem>
            <MenuItem value="oldest">Oldest First</MenuItem>
            <MenuItem value="title">Title A–Z</MenuItem>
          </TextField>

          <TextField
            select
            label="Filter"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            size="small"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="published">Published</MenuItem>
            <MenuItem value="draft">Draft</MenuItem>
          </TextField>

          <Button
            variant="outlined"
            onClick={() => setSearchTerm('')}
            style={{ height: '40px', alignSelf: 'center' }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            className="post-job-btn"
            onClick={() => {
              setFormData({
                title: '',
                description: '',
                link: '',
                image: null,
                draft: false,
              });
              setEditMode(false);
              setSelectedJobId(null);
              setOpen(true);
            }}
          >
            Post Job
          </Button>
        </div>

        <p style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          Showing {filteredJobs.length}{' '}
          {filteredJobs.length === 1 ? 'job' : 'jobs'}
        </p>

        <div className="job-grid-container">
          {filteredJobs.slice(0, visibleJobs).map((job) => (
            <div className="job-card" key={job._id}>
              {job.draft && <span className="jobpost-draft-badge">Draft</span>}
              <img
                className="job-image"
                src={
                  job.image?.filePath
                    ? `${API_BASE_URL}/${job.image.filePath}`
                    : '/logo.png'
                }
                alt={job.title}
              />
              <h3>{job.title}</h3>
              <p className="job-description">{job.description}</p>
              <a href={job.link} target="_blank" rel="noopener noreferrer">
                Open Job Link
              </a>
              <p>
                <strong>Views:</strong> {job.views || 0}
              </p>

              <div className="job-card-actions">
                <button onClick={() => handleEditJob(job._id)}>Edit</button>
                <button onClick={() => handleDeleteDialogOpen(job._id)}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredJobs.length === 0 && (
          <p style={{ textAlign: 'center', marginTop: '2rem', color: '#888' }}>
            No jobs found. Try adjusting your search or check back later.
          </p>
        )}

        {visibleJobs < filteredJobs.length && (
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <Button
              variant="outlined"
              onClick={() => setVisibleJobs((prev) => prev + 8)}
            >
              Load More
            </Button>
          </div>
        )}
      </div>

      {/* Confirm Delete Job Dialog Box */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle className="dialog-title">Delete Job</DialogTitle>
        <DialogContent className="dialog-content">
          Are you sure you want to delete this job?
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDeleteJob}>Delete</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle className="dialog-title">
          {editMode ? 'Edit Job' : 'Post a New Job'}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <TextField
            name="title"
            fullWidth
            margin="dense"
            label="Title"
            value={formData.title}
            className="input-field"
            onChange={handleChange}
          />
          <TextField
            name="description"
            fullWidth
            margin="dense"
            label="Description"
            multiline
            rows={3}
            value={formData.description}
            className="input-field"
            onChange={handleChange}
          />
          <TextField
            name="link"
            fullWidth
            margin="dense"
            label="Insert Link Here"
            value={formData.link}
            className="input-field"
            onChange={handleChange}
          />
          <label className="custom-file-upload">
            <input type="file" onChange={handleFileChange} />
            {formData.image ? 'Change Image' : 'Choose Image'}
          </label>

          {formData.image && (
            <img
              src={
                typeof formData.image === 'string'
                  ? `${API_BASE_URL}/${formData.image}`
                  : URL.createObjectURL(formData.image)
              }
              alt="Preview"
              style={{
                width: '300px',
                height: '200px',
                objectFit: 'contain',
                marginTop: '10px',
              }}
            />
          )}
        </DialogContent>

        <DialogActions className="dialog-actions">
          <div className="draft-toggle">
            <label>
              <input
                type="checkbox"
                checked={formData.draft}
                onChange={(e) =>
                  setFormData({ ...formData, draft: e.target.checked })
                }
              />
              <span>Save as Draft</span>
            </label>
          </div>

          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            className="post-job-btn"
            onClick={editMode ? handleUpdateJob : handlePostJob}
          >
            {editMode ? 'Update Job' : 'Post Job'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default JobPost;
